// @flow
import React from "react";
import * as genericAnimation from "./loading_anim_generic";
import Lottie from "react-lottie";
import {AnimationContainer} from "./SpinnerStyle";

const basicAnimationOptions = {
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: genericAnimation,
    rendererSettings: {
        progressiveLoad: true
    }
};

type OwnProps = {||}

const Spinner = (props: OwnProps) => {
    return (
        <AnimationContainer>
            <Lottie
                options={basicAnimationOptions}
                isStopped={false}
                isPaused={false}
            />
        </AnimationContainer>);
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/Components/Spinner/Spinner.js